// extracted by mini-css-extract-plugin
export default {"root":"HCxor","spinner":"md0f1"};